<div class="dropdown__items-container">
  <div *ngIf="title" class="dropdown__title">{{ title | translate }}</div>
  <div
    *ngFor="let item of items"
    (click)="!item.isDisabled && itemSelection($event, item.type)"
    class="dropdown__items"
    [ngClass]="{ 'dropdown__items--disabled': item.isDisabled }"
    [ngStyle]="{ backgroundColor: item?.backgroundColor }"
  >
    <ng-container *ngIf="item.icon">
      <monorepo-zf-icon [iconName]="item.icon" [iconClasses]="['zf-icon--margin-none']"></monorepo-zf-icon>
    </ng-container>
    {{ item.displayText | translate }}
  </div>
</div>
